import { FiChevronDown } from "react-icons/fi";
import { motion } from "framer-motion";
import { useState } from "react";
import styles from "./dropdown.module.css";

const DropDown = ({ items, setElement, selectedItem }) => {
  const [open, setOpen] = useState(false);

  const getSelectedItemLablel = () => {
    for (let i = 0; i < items?.length; i++) {
      if (items[i].value === selectedItem) {
        return items[i].label;
      }
    }
    return "";
  };

  return (
    <div className={styles.container}>
      <motion.div
        animate={open ? "open" : "closed"}
        className={styles.dropdownWrapper}
      >
        <div
          className={`${styles.toggleButton} ${styles.shimmerEffect}`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          onClick={() => setOpen((prev) => !prev)}
        >
          <button className={styles.button}>
            <span className={styles.toggleText}>
              {selectedItem ? getSelectedItemLablel() : "Select Artist Type"}
            </span>
          </button>
          <motion.span variants={iconVariants}>
            <FiChevronDown />
          </motion.span>
        </div>

        <motion.ul
          initial={wrapperVariants.closed}
          variants={wrapperVariants}
          style={{ originY: "top", translateX: "-50%" }}
          className={styles.dropdownList}
        >
          {items?.map((item) => (
            <Option
              key={item}
              text={item}
              setOpen={setOpen}
              setElement={setElement}
              label={item.label}
              value={item.value}
            />
          ))}
        </motion.ul>
      </motion.div>
    </div>
  );
};

const Option = ({ text, setOpen, setElement, label, value }) => {
  return (
    <motion.li
      variants={itemVariants}
      onClick={() => {
        setElement(value);
        setOpen(false);
      }}
      className={styles.optionItem}
    >
      <span>{label}</span>
    </motion.li>
  );
};

export default DropDown;

// Framer motion variants
const wrapperVariants = {
  open: {
    scaleY: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
    },
  },
  closed: {
    scaleY: 0,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
    },
  },
};

const iconVariants = {
  open: { rotate: 180 },
  closed: { rotate: 0 },
};

const itemVariants = {
  open: {
    opacity: 1,
    y: 0,
    transition: {
      when: "beforeChildren",
    },
  },
  closed: {
    opacity: 0,
    y: -15,
    transition: {
      when: "afterChildren",
    },
  },
};
